 
import { Button, CIActionBtnGroup, CITooltip, Input, MyIcon } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from '../../../../../../../store/AppStore';
import { specialCharacter, SERVICE_OPERATIONS_ERRORS, nonSpaceCharacter, SERVICE_OPERATION_MAXLENGTH, MQ_HEADER_KEY, FORM_SERVICE_TYPE, HEADER_KEY, invalidEventKeys } from '../../../../../../../constants';
import { IHeaderParam } from '../../../../../../../models';

import classes from './ServiceOpsQueryItem.module.scss';

interface IHeaderPathParamProps {
  index: number,
  headerParamKey: string,
  value: string,
  isEdit: boolean | undefined
  isView: boolean;
  updateHeader: (obj: IHeaderParam) => void;
  deleteHeader: any;
  headerList?: IHeaderParam[];
}
const ServiceOperationHeaderItem = ({ index, headerParamKey, value, isEdit, updateHeader, deleteHeader, isView, headerList }: IHeaderPathParamProps) => {
  const [headerKey, setHeaderKey] = useState(headerParamKey);
  const [headerValue, setHeaderValue] = useState(value);
  const [editClicked, setEditClicked] = useState(isEdit);
  const [oldKey, setOldKey] = useState('');
  const [oldValue, setOldVaue] = useState('');
  const [error, setError] = useState('');
  const [valueError, setValueError] = useState('');
  const [isHeaderKeyValid, setIsHeaderKeyValid] = useState<boolean>(true);
  const [isHeaderValueValid, setIsHeaderValueValid] = useState<boolean>(true);
  const { serviceType } = useSelector((state) => state.serviceDetailsReducer);
  const { t: translate } = useTranslation();

  /**
 Validating the key and value input in header params
 */
  let keyError;
  const keyValidation = (e: string) => {
    if (specialCharacter.test(e) && e.length <= 500) {
      setIsHeaderKeyValid(true);
    } else {
      setIsHeaderKeyValid(false);
      if (e.length > 500) {
        keyError = translate(
          'service_operation_form_validation_component.err_max_char_limit',
          { replace: { maxChars: 500 } }
        );
        setError(keyError);
      } else {
        keyError = SERVICE_OPERATIONS_ERRORS.invalidKey;
        setError(keyError);
      }
    }
  };

  const { importStatus } = useSelector(
    (state) => state.serviceOperationReducer
  );
  // Form validation for header key on import
  useEffect(() => {
    keyValidation(headerKey);
  }, [importStatus]);

  const isUpdateHeaderBtnEnabled = () => !!(isHeaderKeyValid && headerKey && isHeaderValueValid && headerValue);
  let paramValueError;
  const valueValidation = (e: string) => {
    if (nonSpaceCharacter.test(e) && e.length <= 500) {
      setIsHeaderValueValid(true);
    } else {
      setIsHeaderValueValid(false);
      if (e.length > 500) {
        paramValueError = translate(
          'service_operation_form_validation_component.err_max_char_limit',
          { replace: { maxChars: 500 } }
        );
        setValueError(paramValueError);
      } else {
        paramValueError = SERVICE_OPERATIONS_ERRORS.invalidValue;
        setValueError(paramValueError);
      }
    }
  };
  useEffect(() => { valueValidation(headerValue); }, [headerValue]);
  const onHeaderChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    keyValidation(event.target.value);
    setHeaderKey(event.target.value);
  };

  const onHeaderValueChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if ((inputType === 'number' && parseInt(event.target.value, 10) < 0) || (inputType === 'number' && event.target.value?.includes('.'))) {
      return;
    }
    valueValidation(event.target.value);
    setHeaderValue(event.target.value);
  };

  /**
   * Checks if a query key exists or not
   */
  useEffect(() => {
    let status = false;
    if (headerList) {
      status = headerList.some((item, itemIndex) => item.key === headerKey && itemIndex !== index);
    }
    if (status) {
      setIsHeaderKeyValid(false);
      keyError = SERVICE_OPERATIONS_ERRORS.headerKeyExists;
      setError(keyError);
    } else if (!status && specialCharacter.test(headerKey) && headerKey.length < parseInt(SERVICE_OPERATION_MAXLENGTH.headerParamMaxLength, 10)) {
      setIsHeaderKeyValid(true);
      keyError = '';
    }
  }, [headerKey, headerList]);

  const [inputType, setInputType] = useState('');

  const onEditHeaderHandler = () => {
    setEditClicked(true);
    setOldKey(headerKey);
    setOldVaue(headerValue);
    if (headerKey === MQ_HEADER_KEY[3].name && serviceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.MQ) {
      setInputType('number');
    } else {
      setInputType('');
    }
  };
  const onCancelHeaderHandler = () => {
    setEditClicked(false);
    setHeaderKey(oldKey);
    setHeaderValue(oldValue);
    setInputType('');
  };
  const onUpdateHeaderHandler = (index: number) => {
    setEditClicked(false);
    updateHeader({ key: headerKey, value: headerValue, index });
    setInputType('');
  };
  const onDeleteHeaderHandler = (index: number) => {
    deleteHeader(index);
  };

  const isHeaderKeyDisabled = () => {
    if (serviceType.toLocaleLowerCase() === FORM_SERVICE_TYPE.MQ) {
      return HEADER_KEY?.some((header) => header === oldKey);
    }
    return false;
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;
    if (inputType === 'number' && invalidEventKeys.includes(key.toLowerCase())) {
      event.preventDefault();
    }
  };

  return (
    <div className={classes['query-list']}>
      <Row className={classes['param-body']}>
        <Col sm={5}>{editClicked ? (
          <div>
            <div className={classes['input-on-edit']}>
              <Input
                name="headerParamKey"
                label=""
                placeholder={String(
                  translate('service_operation_details_form.header_param_key')
                )}
                onChange={onHeaderChangeHandler}
                value={headerKey}
                data-testid="header-change"
                error={!isHeaderKeyValid}
                maxLength={Number(SERVICE_OPERATION_MAXLENGTH.headerParamMaxLength)}
                errorTxt={error}
                disabled={isHeaderKeyDisabled()}
              />
            </div>
          </div>) : <div className={classes['table-items']}><CITooltip placement="right" message={headerKey}><p className={classes['ops-item-tooltip']} data-testid="row-headerkey">{headerKey}</p></CITooltip></div>}
        </Col>
        <Col sm={5}>{editClicked ? (
          <div>
            <div className={classes['input-on-edit']}>
              <Input
                name="headerParamValue"
                label=""
                placeholder={
                  inputType.length
                    ? String(translate('service_operation_form.header_param_value_num'))
                    : String(translate('service_operation_form.header_param_value'))
                }
                onChange={onHeaderValueChangeHandler}
                value={headerValue}
                error={!isHeaderValueValid}
                errorTxt={valueError}
                maxLength={Number(SERVICE_OPERATION_MAXLENGTH.headerParamMaxLength)}
                type={inputType}
                onKeyUp={onKeyDown}
                onKeyDown={onKeyDown}
                data-testid="header-value-change"
              />
            </div>
          </div>) : <div className={classes['table-items']}><CITooltip placement="right" message={headerValue}><p className={classes['ops-item-tooltip']} data-testid="row-headervalue">{headerValue}</p></CITooltip></div>}
        </Col>
        {isView ? <Col sm={2} /> : (
          <Col sm={2} className={classes.buttons}>
            {!editClicked ? (
              <span className={classes['edit-buttons']}>
                <CIActionBtnGroup
                  buttons={[
                    {
                      label: 'edit',
                      key: 'editIcon',
                      variant: 'tertiary',
                      onClick: async () => onEditHeaderHandler(),
                      testId: 'edit-btn'
                    },
                    {
                      label: 'delete',
                      key: 'deleteIcon',
                      variant: 'tertiary',
                      onClick: async () => onDeleteHeaderHandler(index),
                      testId: 'delete-btn'
                    }]}
                />
              </span>
            ) : (
              <div className={classes['check-buttons']}>
                <Button
                  variant="tertiary"
                  className={classes['update-button']}
                  disabled={!isUpdateHeaderBtnEnabled()}
                  onClick={() => onUpdateHeaderHandler(index)}
                  data-testid="update-btn"
                  aria-label="update-btn"
                >
                  <MyIcon name="thinCheckIcon" />
                </Button>
                <Button
                  variant="tertiary"
                  onClick={() => onCancelHeaderHandler()}
                  data-testid="cancel-btn"
                  className={classes['cancel-button']}
                  aria-label="cancel-btn"
                >
                  <MyIcon name="xMarkLargeIcon" />
                </Button>
              </div>)}
          </Col>)}
      </Row>
    </div>);
};

export default ServiceOperationHeaderItem;
